import { WatchDogTab } from './WatchDogTab';

export default WatchDogTab;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/WatchDogTab/index.ts